import PropTypes from 'prop-types';
import { Stack, InputAdornment, TextField, Autocomplete } from '@mui/material';
// components
import Iconify from '../../../fl-components/Iconify';

// ----------------------------------------------------------------------

InviteTableToolbar.propTypes = {
  filterName: PropTypes.string,
  filterRole: PropTypes.string,
  onFilterName: PropTypes.func,
  onFilterClass: PropTypes.func,
  optionsClass: PropTypes.arrayOf(PropTypes.string)
};

export default function InviteTableToolbar({
  filterName,
  onFilterName,
  onFilterClass,
  optionsClass
}) {
  return (
    <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} sx={{ py: 2.5, px: 3 }}>
      <Autocomplete
        options={optionsClass}
        getOptionLabel={(option) => option.name}
        sx={{ maxWidth: { xs: '100%', sm: 240 }, minWidth: { xs: '100%', sm: 240 } }}
        onChange={(e, newValue) => {
          onFilterClass(newValue?.id ?? newValue?._id ?? 'all');
        }}
        renderInput={(params) => <TextField {...params} label="Choose a class" />}
      />

      <TextField
        fullWidth
        value={filterName}
        onChange={(event) => onFilterName(event.target.value)}
        placeholder="Search user..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify
                icon="eva:search-fill"
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          )
        }}
      />
    </Stack>
  );
}
